import * as React from 'react';
import careStore from "../../store/careStore";
import { useEffect } from "react";
import api from "../../utils/api";

import Top from "../Top";
import Bottom from "../Bottom";
import CareStretching from '../../components/CareStretching';
import colorrunning from "../../assets/icon/colorrunning.gif";
import lifting from "../../assets/icon/lifting.gif";
import yoga from "../../assets/icon/yoga.gif";
import CardActions from '@mui/material/CardActions';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import Fade from '@mui/material/Fade';
import Slide, { SlideProps } from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from '@mui/material/Skeleton';



function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

const CareSports = () => {
  /* const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false); */
  const navigate = useNavigate();
  const storeData: any = careStore();
  const [loading, setLoading] = React.useState(false);
  const [customerProgram, setCustomerProgram] = React.useState({
    aerobic: '',
    attention: '',
    cholesterol: '',
    create_date: '',
    exerciseRecommand: [],
    exercisetime: '',
    fat: '',
    member_id: '',
    month: '',
    program_name: '',
    recommandedcalperday: '',
    salt: '',
    stretching: [{ name: '', exercise_time: '', url: '' }],
    sugar: '',
    week: '',
    weight: [{ name: '', exercise_time: '', url: '' }],
    worktime: '',
    year: ''
  });

  useEffect(() => {

    setLoading(true);
    // 맞춤플랜 상황에 맞게 조회해오기
    setTimeout(() => {
      api.get(`app/api/v1/AP_004_002`).then(res => {
        const planCode = res.data.result_code;
        if (planCode === '0') { // 생성된 맞춤플랜 있음(7일 지나지 않음)
          const resultData = JSON.parse(res.data.result_data);
          setCustomerProgram(resultData);
        } else if (planCode === '100') {  // 맞춤플랜 생성 전 or 맞춤플랜 산출 7일 지나서 재생성
          getPlan();
        }
        setLoading(false);
      }).catch(function (error) {
        console.log(error)
      });
    }, 500);

  }, []);

  // 맞춤플랜 생성(최초 생성, 7일 지나서 재생성 포함)
  function getPlan() {
    api.post(`app/api/v1/AP_004_003`, storeData.careInfo).then(res => {
      const resultData = JSON.parse(res.data.result_data);
      setCustomerProgram(resultData);
    }).catch(function (error) {
      console.log(error)
    });
  }

  const [state, setState] = React.useState<{
    open: boolean;
    Transition: React.ComponentType<
      TransitionProps & {
        children: React.ReactElement<any, any>;
      }
    >;
  }>({
    open: false,
    Transition: Fade,
  });

  const handleClick = (
    Transition: React.ComponentType<
      TransitionProps & {
        children: React.ReactElement<any, any>;
      }
    >,
  ) =>
    () => {
      setState({
        open: true,
        Transition,
      });
    };

  const handleClose = () => {
    setState({
      ...state,
      open: false,
    });
  };

  const programInfo = (
    <React.Fragment>
      <Stack direction={'row'}>
        <Stack sx={ModalTextStyle} >
          <Avatar alt="" src={yoga} sx={{ m: 'auto' }} />
          <Typography sx={{ fontSize: 12, pt: 1 }}>
            {'스트레칭 (약 ' + customerProgram.stretching.map((v: any) => v.exercise_time).reduce((a, b) => a + b, 0) + '분)'}
          </Typography>
        </Stack>
        <Stack sx={{ flex: 2, justifyContent: 'center' }}>
          {customerProgram.stretching.map((item: any, index: any) => (
            <Typography key={index} sx={ModalBodyTextStyle}>
              {item.name + ' (' + item.exercise_time + '분)'}
            </Typography>
          ))}
        </Stack>
      </Stack>

      <Divider sx={{ borderColor: "#000" }} />
      <Divider sx={{ borderColor: "#555" }} />

      <Stack direction={'row'} >
        <Stack sx={ModalTextStyle}>
          <Avatar alt="" src={lifting} sx={{ m: 'auto', }} />
          <Typography sx={{ fontSize: 12, pt: 1 }}>
            {'근력운동 (약 ' + customerProgram.weight.map((v: any) => v.exercise_time).reduce((a, b) => a + b, 0) + '분)'}
          </Typography>
        </Stack>
        <Stack sx={{ flex: 2, justifyContent: 'center' }}>
          {customerProgram.weight.map((item: any, index: any) => (
            <Typography key={index} sx={ModalBodyTextStyle}>
              {item.name + ' (' + item.exercise_time + '분)'}
            </Typography>
          ))}
        </Stack>
      </Stack>

      <Divider sx={{ borderColor: "#000" }} />
      <Divider sx={{ borderColor: "#555" }} />

      <Stack direction={'row'}>
        <Stack sx={ModalTextStyle}>
          <Avatar alt="" src={colorrunning} sx={{ m: 'auto' }} />
          <Typography sx={{ fontSize: 12, pt: 1 }}>
            유산소
          </Typography>
        </Stack>
        <Stack sx={{ flex: 2, justifyContent: 'center' }}>
          <Typography sx={ModalBodyTextStyle}>
            {customerProgram.aerobic}
          </Typography>
        </Stack>
      </Stack>
    </React.Fragment>
  );



  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 13, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title="케 어" />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%', minHeight: 500 }}>
        <Box sx={{ boxSizing: 'border-box', }}>
          {loading ? (
            <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
              <Skeleton variant="rounded" height={30} width="60%" sx={{ mt: 4 }} />
            </Box>
          ) : (
            <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
              {customerProgram.year}.{customerProgram.month}. [{customerProgram.week}주차]
            </Typography>
          )}

          {loading ? (
            <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
              <Skeleton variant="rounded" height={36} width="100%" sx={{ mt: 3 }} />
            </Box>
          ) : (
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 3, bgcolor: '#ffb068', borderRadius: '20px' }}>
              <CareButton variant="contained" sx={{ bgcolor: '#FFB068', color: '#fff' }}
                onClick={() => {
                  navigate('/care/CareMenu');
                }}
              >
                맞춤식단
              </CareButton>
              <CareButton variant="contained"
                onClick={() => {
                  navigate('/care/CareSports');
                }}
              >
                맞춤운동
              </CareButton>
            </Stack>
          )}


          <React.Fragment>

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={20} width="60%" sx={{ mt: 4 }} />
              </Box>

            ) : (
              <Typography component="div" sx={{ fontSize: 16, fontWeight: 600, color: '#555', m: 4, mb: 0, textAlign: 'center' }}>
                하루에 이 만큼 운동하세요!
              </Typography>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center' }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={245} width="100%" sx={{ mt: 3, }} />
              </Box>
            ) : (
              <Box sx={{ m: '20px auto 0 auto', bgcolor: '#fff', p: '10px', borderRadius: 5, boxSizing: 'border-box', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
                <Stack direction="row" justifyContent="center" alignItems="baseline" spacing={1} sx={{ mb: 1 }} >
                  <Typography component="span" sx={{ fontSize: 15, color: '#777', m: 0, mb: 0, fontWeight: 700 }}>
                    조깅기준
                  </Typography>
                  <Typography component="span" sx={{ fontSize: 30, color: '#0a0dab', m: 0, mb: 0, fontWeight: 700 }}>
                    {Math.round(Math.abs(Number(customerProgram.exercisetime)))}
                  </Typography>
                  <Typography component="span" sx={{ fontSize: 15, color: '#777', m: 0, mb: 0, fontWeight: 500 }}>
                    min
                  </Typography>
                </Stack>

                <Divider variant="middle" />

                <Stack direction="row" spacing={2}
                  sx={{
                    m: 1,
                    '& .MuiStack-root': { flex: 1, alignItems: 'center' },
                    '& .MuiAvatar-root': { border: '1px solid #ef8322', mt: 1 },
                    '& .MuiTypography-root': { fontSize: 14, color: '#777', textAlign: 'center', mt: 1, mb: 1 },
                    '& .subText': { fontSize: 12, fontWeight: 400, m: 0 },
                  }}>

                  <Stack direction="column" justifyContent="center" >
                    <Avatar alt="" src={yoga} sx={{}} />
                    <Typography component="div">
                      스트레칭<br />{'(약 ' + customerProgram.stretching.map((v: any) => v.exercise_time).reduce((a, b) => a + b, 0) + '분)'}
                    </Typography>
                  </Stack>

                  <Stack direction="column" justifyContent="center" >
                    <Avatar alt="" src={lifting} sx={{}} />
                    <Typography component="div" sx={{}}>
                      근력운동<br />{'(약 ' + customerProgram.weight.map((v: any) => v.exercise_time).reduce((a, b) => a + b, 0) + '분)'}
                    </Typography>
                  </Stack>

                  <Stack direction="column" justifyContent="center" >
                    <Avatar alt="" src={colorrunning} sx={{}} />
                    <Typography component="div">
                      유산소<br /> 운동
                    </Typography>
                  </Stack>
                </Stack>
                <Divider variant="middle" />
                <CardActions sx={{ justifyContent: 'end' }} onClick={handleClick(SlideTransition)}>
                  <Button size="small" sx={{ color: '#EF8322' }}>전체 프로그램 설명보기 <ArrowForwardIosIcon sx={{ fontSize: '14px', ml: '3px' }} /></Button>
                </CardActions>
              </Box>

            )}
            {/*  bottom popup 전체 프로그램 설명  */}
            <Box className="bottomStyle">
              <Snackbar
                open={state.open}
                onClose={handleClose}
                TransitionComponent={state.Transition}
                message={programInfo}
                key={state.Transition.name}
                autoHideDuration={7000}
                sx={{
                  '& .MuiPaper-elevation': { display: 'block' }
                }}
              />
            </Box>
            {/* / ------------------------------  / */}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'right', }} justifyContent='end' alignContent={'end'}>
                <Skeleton variant="rounded" height={20} width="90%" sx={{ mt: 1 }} />
              </Box>
            ) : (
              <Typography sx={{ textAlign: 'right', fontSize: 11, color: '#aaa', mt: 1, mb: 3 }}>출처 : 질병관리청(국가건강정보포털),  <a href="https://health.kdca.go.kr/healthinfo/biz/health/main/mainPage/main.do" title="질병관리청" target='_blank' style={{ textDecoration: 'none', color: '#aaa', fontSize: 11 }}>https://health.kdca.go.kr</a></Typography>

            )}


            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center' }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={330} width="100%" sx={{ mt: 3, }} />
              </Box>
            ) : (
              <Box sx={{ justifyContent: 'center', flexDirection: 'column', bgcolor: '#fff', borderRadius: 5, boxSizing: 'border-box', m: 'auto' }}>
                <Typography component="div" sx={{ fontSize: 16, fontWeight: 600, color: '#777', m: 'auto', textAlign: 'center', p: '15px 0 10px 0', bgcolor: '#fff', borderRadius: '15px 15px 0 0 ', }}>
                  오늘의 스트레칭
                </Typography>
                <Card sx={{ borderRadius: '0 0 15px 15px', }}>
                  <CareStretching stretchingData={customerProgram.stretching} />
                </Card>
              </Box>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center' }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={330} width="100%" sx={{ mt: 3, }} />
              </Box>
            ) : (
              <Box sx={{ justifyContent: 'center', flexDirection: 'column', bgcolor: '#fff', borderRadius: 5, boxSizing: 'border-box', m: '20px auto 0 auto' }}>
                <Typography component="div" sx={{ fontSize: 16, fontWeight: 600, color: '#777', m: 'auto', textAlign: 'center', p: '15px 0 10px 0', bgcolor: '#fff', borderRadius: '15px 15px 0 0 ', }}>
                  오늘의 근력운동
                </Typography>
                <Card sx={{ borderRadius: '0 0 15px 15px', }}>
                  <CareStretching stretchingData={customerProgram.weight} />
                </Card>
              </Box>
            )}


            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center' }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={330} width="100%" sx={{ mt: 3, }} />
              </Box>
            ) : (
              <Box sx={{ justifyContent: 'center', flexDirection: 'column', bgcolor: '#fff', borderRadius: 5, boxSizing: 'border-box', m: '20px auto 0 auto' }}>
                <Typography component="div" sx={{ fontSize: 16, fontWeight: 600, color: '#777', m: 'auto', textAlign: 'center', p: '15px 0 10px 0', bgcolor: '#fff', borderRadius: '15px 15px 0 0 ', }}>
                  유산소 운동 한가지
                </Typography>
                <Card sx={{ borderRadius: '0 0 15px 15px', p: 2 }}>
                  {customerProgram.exerciseRecommand.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      <Stack direction="row" spacing={2} sx={{ p: 1 }}>
                        <Typography>
                          {item.name}
                        </Typography>
                        <Typography sx={{ justifyContent: 'end', display: 'flex', flex: 1, fontWeight: '600' }}>
                          {Math.round(Math.abs(Number(item.time)))}분
                        </Typography>
                      </Stack>
                      <Divider />
                    </React.Fragment>
                  ))}
                </Card>
              </Box>
            )}


            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center' }} justifyContent='center' alignContent={'center'}>
                <Skeleton variant="rounded" height={220} width="100%" sx={{ mt: 3, }} />
              </Box>
            ) : (
              <Box
                sx={{
                  justifyContent: 'center',
                  flexDirection: 'column',
                  bgcolor: '#e1e1e1',
                  borderRadius: 4,
                  boxSizing: 'border-box',
                  m: '20px auto 0 auto',
                  p: 2,
                  border: '1px solid #ef8322',
                  boxShadow: 'inset 0 0 1px 1px #fff'
                }}>
                <Typography component="div" sx={{ fontSize: 14, fontWeight: 600, color: '#db0909', textAlign: 'center', mb: 1 }}>
                  주의사항
                </Typography>
                <Divider sx={{ borderColor: '#bbb' }} />
                <Divider sx={{ borderColor: '#fff' }} />
                <Typography sx={{ fontSize: 14, mt: 1 }}>
                  근력운동은 주 2회로, 숨이 조금 찰 정보(RPE 11)의 강도로 하는 것을 권장함. 운동 전후로 혈압체크, 안정 시 혈압이 180/110mmHg 이상일 경우 운동 중단. 운동 중 숨참기 삼가.
                  고혈압 증세가 있을 경우 즉시 중단해야함. 세트당 개수를 많지 않게 유지하며, 세트 사이 1분 이상의 충분한 휴식시간 가지기.
                </Typography>
              </Box>
            )}

            {loading ? (
              <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'right', }} justifyContent='end' alignContent={'end'}>
                <Skeleton variant="rounded" height={20} width="90%" sx={{ mt: 1 }} />
              </Box>
            ) : (
              <Typography sx={{ textAlign: 'right', fontSize: 11, color: '#aaa', mt: 1, mb: 3 }}>출처 : 질병관리청(국가건강정보포털),  <a href="https://health.kdca.go.kr/healthinfo/biz/health/main/mainPage/main.do" title="질병관리청" target='_blank' style={{ textDecoration: 'none', color: '#aaa', fontSize: 11 }}>https://health.kdca.go.kr</a></Typography>

            )}
          </React.Fragment>

        </Box>

        {loading ? (
          <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center' }} justifyContent='center' alignContent={'center'}>
            <Skeleton variant="rounded" height={50} width="100%" sx={{ mt: 3, }} />
          </Box>
        ) : (

          <Box sx={BtnStyle}>
            <Button variant="contained" sx={BottomBtnStyle}
              onClick={(e) => {
                storeData.setCareInfo('height', '');
                storeData.setCareInfo('weight', '');
                storeData.setCareInfo('bmi', 0);
                storeData.setCareInfo('interest_disease', '');
                storeData.setCareInfo('work_strength', '');
                storeData.setCareInfo('goal', '');
                storeData.setCareInfo('food', '');
                storeData.setCareInfo('reset', 'Y');
                navigate('/care/careStep');
              }} >
              맞춤플랜 설정 다시 하기
            </Button>
          </Box>
        )}
      </Grid>

      <Bottom />
    </Stack >
  );
}

const ProgramInfostyle = {
  position: 'absolute' as 'absolute',
  top: '100%',
  left: '50%',
  transform: 'translate(-50%, -0%)',
  maxWidth: '460px',
  p: 5,
};

const ModalTextStyle = {
  textAlign: 'center',
  flex: 1,
  p: '15px 10px 15px 0'
};

const ModalBodyTextStyle = {
  fontSize: 12,
  m: '0 0 5px 0'
};

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '50%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: '3 0',
  mt: 5,
  boxSizing: 'border-box',
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#fff',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#EF8322',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default CareSports;